import { onUnmounted, ref } from 'vue'

const TOOLTIP_SHOW_DELAY_MS = 250

export const useContactHoverTooltip = (delay = TOOLTIP_SHOW_DELAY_MS) => {
  const mouseX = ref<number | null>(null)
  const mouseY = ref<number | null>(null)
  const isTooltipVisible = ref(false)

  let debounceTimeout: ReturnType<typeof setTimeout> | null = null

  const onMouseEnter = () => {
    debounceTimeout = setTimeout(() => {
      isTooltipVisible.value = true
    }, delay)
  }

  const onMouseOver = (e: MouseEvent) => {
    mouseX.value = e.clientX
    mouseY.value = e.clientY
  }

  const onMouseLeave = () => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout)
      debounceTimeout = null
    }
    isTooltipVisible.value = false
  }

  onUnmounted(() => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout)
    }
  })

  return {
    mouseX,
    mouseY,
    isTooltipVisible,
    onMouseEnter,
    onMouseOver,
    onMouseLeave,
  }
}
